import { render, staticRenderFns } from "./svcDiscountBase.vue?vue&type=template&id=661b552e&"
import script from "./svcDiscountBase.vue?vue&type=script&lang=js&"
export * from "./svcDiscountBase.vue?vue&type=script&lang=js&"
import style0 from "./svcDiscountBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661b552e')) {
      api.createRecord('661b552e', component.options)
    } else {
      api.reload('661b552e', component.options)
    }
    module.hot.accept("./svcDiscountBase.vue?vue&type=template&id=661b552e&", function () {
      api.rerender('661b552e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/svcManage/svcDiscount/svcDiscountBase.vue"
export default component.exports